/**
 * Label ARIA dialog / alertdialog nodes that lack an accessible name.
 * Targets Shopify Forms floating popups (outer section[role=dialog] in shadow DOM)
 * and any other unnamed dialogs in light DOM.
 */
(function () {
  'use strict';

  var OBSERVED = typeof WeakSet !== 'undefined' ? new WeakSet() : null;

  function hasName(el) {
    var label = el.getAttribute('aria-label');
    if (label && label.trim()) return true;
    var ids = el.getAttribute('aria-labelledby');
    if (!ids) return false;
    var root = el.getRootNode ? el.getRootNode() : document;
    return ids.split(/\s+/).some(function (id) {
      if (!id) return false;
      var ref = root.getElementById ? root.getElementById(id) : document.getElementById(id);
      return !!(ref && (ref.textContent || '').trim());
    });
  }

  function deriveName(dialog) {
    var child = dialog.querySelector(
      '[role="dialog"][aria-label], [role="alertdialog"][aria-label]'
    );
    if (child) {
      var childLabel = child.getAttribute('aria-label');
      if (childLabel && childLabel.trim()) return childLabel.trim();
    }
    var heading = dialog.querySelector('h1, h2, h3, h4, h5, h6');
    if (heading) {
      var text = (heading.textContent || '').trim();
      if (text) return text;
    }
    return 'Dialog';
  }

  function labelDialog(dialog) {
    if (!dialog || hasName(dialog)) return;
    dialog.setAttribute('aria-label', deriveName(dialog));
  }

  function walk(root) {
    if (!root || !root.querySelectorAll) return;
    var dialogs = root.querySelectorAll('[role="dialog"], [role="alertdialog"]');
    for (var i = 0; i < dialogs.length; i++) labelDialog(dialogs[i]);

    var all = root.querySelectorAll('*');
    for (var j = 0; j < all.length; j++) {
      var el = all[j];
      if (el.shadowRoot) {
        observeRoot(el.shadowRoot);
        walk(el.shadowRoot);
      }
    }
  }

  function observeRoot(root) {
    if (!root || !observer) return;
    if (OBSERVED) {
      if (OBSERVED.has(root)) return;
      OBSERVED.add(root);
    } else if (root.__dwDialogA11y) {
      return;
    } else {
      root.__dwDialogA11y = true;
    }
    observer.observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['role', 'aria-label', 'aria-labelledby']
    });
  }

  function scan() {
    walk(document);
  }

  var observer = new MutationObserver(function () {
    scan();
  });

  function start() {
    observeRoot(document.documentElement);
    scan();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
